import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsAnalyticsDataViewCreateRoute: InvariantJiraRoute = {
	name: 'assets-analytics-data-view-create',
	path: '/jira/assets/analytics/data-view/create',
	exact: true,
};
